import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController, LoadingController } from 'ionic-angular';

import { TaskMarketing as Task, UserMarketing as User, HelperMyRadiant } from '@providers/index';
import { FormTaskPage, DetailTaskPage } from '../'

@Component({
  selector: 'page-task',
  templateUrl: 'page.html'
})
export class TaskPage {

  listTask : any ;
  tender:any = {};
  loading:any; 
  params:any={};
  can_edit=false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public taskApi: Task,
    public userApi: User,
    public helper : HelperMyRadiant,
  ) {
    
    if(this.navParams.get('tender')!=undefined){
      this.tender = this.navParams.get('tender');
    }

    if(this.userApi.akses.edit_tender_group_data=='branch'){
      if(this.tender.branch_id == this.userApi.group.user_data){
        this.can_edit=true;
      }
    }else if(this.userApi.akses.edit_tender_group_data=='all'){
      this.can_edit = true;
    }else if(this.userApi.akses.edit_tender_group_data=='mine'){
      if(this.tender.created_by == this.userApi.data.employee_id){
        this.can_edit=true;
      }
    }
  }
  
  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  ionViewWillEnter(){
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  getList(){
    this.showLoading();
    let params:any = {};
    if(this.tender.id!=undefined){
      params.tender_id = this.tender.id
    }
    this.taskApi.get(params).subscribe((resp:any) => {
      this.listTask = resp.data;
      this.loading.dismiss();
    },(err) => {
      this.presentToast('Failed to Load Data.');
      this.loading.dismiss();
    });
  }

  add(){
    this.navCtrl.push(FormTaskPage, {
      tender : this.tender
    })
  }

  edit(rec) {
    this.navCtrl.push(FormTaskPage, {
      tender: this.tender,
      rec:rec
    });
  }

  detail(rec) {
    this.navCtrl.push(DetailTaskPage, {
      tender: this.tender,
      rec:rec
    });
  }

  deleteTask(item) {
    let params = {
      id : item.id,
      tender_id : item.tender_id
    }

    let me = this,
      optionsSwal = {
      title: "Are you sure ?",   
      desc:"Once you delete task, you cant't undo it. ",   
      icon: "",
      dangerMode: false,
      btnCancel: "Cancel",
      btnConfirm: "Delete",
    }
    this.helper.presentSwalConfirmation(optionsSwal, () => {
      me.loading = me.helper.showLoading("Please Wait...");
      me.taskApi.delete(params).subscribe((resp:any) => {        
        if (resp.success) {       
          try {
            me.loading.dismiss();
          } catch (error) {
          }
          me.helper.presentToast(resp.msg);
          me.getList();
        } else {
          me.helper.presentToast(resp.msg);
        }
      }, (err) => {
        try {
          me.loading.dismiss();
        } catch (error) {

        }
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/marketing/task/page.ts